module.exports = __webpack_public_path__ + "static/media/profile.19cf004a.jpeg";